export const BUTTON_ICON = {
  settings: "settings",
  moreVertical: "more-vertical",
  chevronLeft: "chevron-left",
  chevronUp: "chevron-up",
  chevronRight: "chevron-right",
  chevronDown: "chevron-down",
  edit: "edit",
  trash: "trash",
  copy: "copy",
  search: "search",
  plus: "plus",
  download: "download",
  arrowLeft: "arrow-left",
  menu: "menu",
  x: "x",
  save: "save",
  minus: "minus",
  code: "code",
} as const;
